/**
 * Melkofpuur Shop Section
 * Handles mobile filter drawer open/close functionality
 * Filters redirect to collection page where Shopify's native filtering works
 */

class MelkofpuurShop {
  constructor() {
    this.section = document.querySelector('.melkofpuur-shop');
    if (!this.section) return;

    // Mobile drawer elements
    this.drawer = document.querySelector('[data-mp-filter-drawer]');
    this.backdrop = document.querySelector('[data-mp-drawer-backdrop]');

    // Buttons
    this.filterToggle = document.querySelector('[data-filter-toggle]');
    this.closeButton = document.querySelector('[data-mp-drawer-close]');

    this.bindEvents();
  }

  bindEvents() {
    // Mobile drawer toggle
    if (this.filterToggle) {
      this.filterToggle.addEventListener('click', () => this.openDrawer());
    }

    // Close drawer
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeDrawer());
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.closeDrawer());
    }

    // Close drawer on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer?.classList.contains('is-open')) {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    if (!this.drawer) return;

    this.drawer.classList.add('is-open');
    this.backdrop?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Focus first element
    const firstFocusable = this.drawer.querySelector('button, input, select, textarea');
    if (firstFocusable) {
      firstFocusable.focus();
    }

    this.filterToggle?.setAttribute('aria-expanded', 'true');
  }

  closeDrawer() {
    if (!this.drawer) return;

    this.drawer.classList.remove('is-open');
    this.backdrop?.classList.remove('is-visible');
    document.body.style.overflow = '';

    this.filterToggle?.setAttribute('aria-expanded', 'false');
    this.filterToggle?.focus();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MelkofpuurShop());
} else {
  new MelkofpuurShop();
}

// Reinitialize on section reload (for Shopify customizer)
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.melkofpuur-shop')) {
      new MelkofpuurShop();
    }
  });
}
